import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { cleverTap, getAppointmentDate, getAppointmentTime } from "../../../services/provider/common";
import { SingleConfirmAppointments, BulkConfirmAppointments } from "../../../services/provider/appointment";
import { CLEVER_TAP_EVENTS, STATUS_CODE_MAP } from '../../../constants/provider/constant';
import { useLocation } from 'react-router';
import { toast } from "react-toast";
import moment from 'moment';

export default function MarkAttendanceAppointmentDialog(props) {

    const location = useLocation();
    const [feedback, setFeedback] = React.useState("");
    const [callbackdate, setCallbackdate] = React.useState(props?.details?.formattedfulfillmentDate ?? "");
    const [markAttendance] = React.useState(props.markAttendance);
    const [details] = React.useState(props.details);
    const [selected] = React.useState(props.selected);
    const [bulkFlag] = React.useState(props.bulkFlag);
    const [notes, setNotes] = React.useState('');
    const [notAttendedReason, setNotAttendedReason] = React.useState("");

    const handleFieldChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;

        switchCase(name, value);
    }

    useEffect(()=>{
        if(bulkFlag)
        cleverTap(CLEVER_TAP_EVENTS.bulkMarkAttendedPopupShown, {
            srcType: "web/mWeb",
            srcPage: location.pathname,
            isPopupShown: 1
        })
        else{
            if(markAttendance)
            cleverTap(CLEVER_TAP_EVENTS.markAttendedPopupShown, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                isPopupShown: 1
            })
            else
            cleverTap(CLEVER_TAP_EVENTS.markNotAttendedPopupShown, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                isPopupShown: 1
            })
        }
    },[bulkFlag, markAttendance, location.pathname])

    console.log("details", details)

    const getRequestIdFromArray = (arrayOfItems) => {
        let id = markAttendance?STATUS_CODE_MAP["Attended"]:STATUS_CODE_MAP["Not Attended"];
        arrayOfItems && arrayOfItems.forEach(element => {
            if (markAttendance && element.action === "Attended") {
                id = element.actionStatusId;
            }else if(!markAttendance && element.action === "NotAttended"){
                id = element.actionStatusId;
            }
        })
        return id;
    }


    const sendBulkPayload = () => {
        let payload = [];

        if (selected && selected.length > 0) {
            selected.forEach(element => {
                payload.push({ requestId: element.requestId, statusId: element.currentStatusId })
            });
        }
        return payload;
    }

    const submitDetails = (event) => {
        event.preventDefault();
        let obj = {}

        if (bulkFlag) {
            cleverTap(CLEVER_TAP_EVENTS.bulkMarkAttendedPopupBtnClick, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "Customer awaited at DC",
                Remarks:notes
            })
            obj = {
                requestIds: sendBulkPayload(),
                requestedNextActionId: STATUS_CODE_MAP["Attended"],
                remark: notes
            }
        } else {
            obj = {
                requestId: details.requestId,
                contractTypeId: details.requestContractType,
                currentStatusId: details.currentStatusId,
                remarks: (markAttendance)?notes:(notAttendedReason==="Others")?notes:notAttendedReason,
                requestedNextActionId: getRequestIdFromArray(details.nextPossibleActions),
                dateOfVisit: callbackdate,
                feedback: feedback,
            }
            cleverTap(markAttendance?CLEVER_TAP_EVENTS.markAttendedPopupBtnClick: CLEVER_TAP_EVENTS.markNotAttendedPopupBtnClick, {
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "Customer awaited at DC",
                requestID : obj.requestId,
                costType : details.additionalInformation.isPaid?"Paid":"Unpaid",
                visitType : details.additionalInformation.visitType,
                testCategory : details.additionalInformation.productName,
                Remarks:obj.remark
            })
        }

        let data = {
            request: obj,
            requestAccessToken: JSON.parse(localStorage.getItem("access_token")),
        }
        console.log(" obj . SUBMIT.", data);

        if (bulkFlag) {
            BulkConfirmAppointments(obj).then(res => {
                console.log("res ..", res)
                if (res.isSuccess) {
                    props.closeDialogAndRefresh("REFRESH");
                    cleverTap(CLEVER_TAP_EVENTS.bulkMarkAttendedSuccess, {
                        srcType: "web/mWeb",
                        srcPage: location.pathname,
                        isSuccess: 1
                    })
                    toast.success("Appointments marked attended")
                }
                else{
                    cleverTap(CLEVER_TAP_EVENTS.bulkMarkAttendedFailed, {
                        srcType: "web/mWeb",
                        srcPage: location.pathname,
                        isSuccess: 1,
                        // failureReason:res.errorMessage
                    })
                    toast.error(`Appointments not marked attended ${res?.errorMessage ?? ""}`)
                }
            })
        } else {
            SingleConfirmAppointments(data).then(res => {
                console.log("res ..", res)
                if (res.isSuccess) {
                    cleverTap(markAttendance?CLEVER_TAP_EVENTS.markAttendedSuccess:CLEVER_TAP_EVENTS.markNotAttendedSuccess, {
                        srcType: "web/mWeb",
                        srcPage: location.pathname ,
                        isSuccess: 1
                    })
                    props.closeDialogAndRefresh("REFRESH");
                    toast.success(`Appointment marked ${markAttendance? "attended" : "not attended"}`)
               }
                else{
                    cleverTap(markAttendance?CLEVER_TAP_EVENTS.markAttendedFailed:CLEVER_TAP_EVENTS.markNotAttendedFailed, {
                        srcType: "web/mWeb",
                        srcPage: location.pathname ,
                        isSuccess: 0
                    })
                    toast.error(`Appointment wasn't marked ${markAttendance ? "attended" : "not attended"} ${res?.errorMessage ?? ""}`)
                }
            })
        }
    }

    const closePopUp = () => {
        props.closeDialog();
    }

    const switchCase = (name, value) => {
        switch (name) {
            case 'feedback':
                setFeedback(value);
                break;
            case 'callbackdate':
                setCallbackdate(value);
                break;
            case 'notes':
                setNotes(value);
                break;
            default:
                break;
        }
    }

    
    const reasons = [
        'Customer not answering the calls',
        'The customer was not available for sample collection & wants to reschedule',
        'The customer was not available for sample collection & wants to cancel ',
        'Others'];

    const rejectionOptions = (
            Boolean(!markAttendance)?
            <div>
            <div className="pb-10">
            <FormControl className="w-full">
                <InputLabel id="notAttendedReason">Reason Not Attended</InputLabel>
                <Select
                labelId="notAttendedReason"
                name="notAttendedReason"
                id="notAttendedReason"
                value={notAttendedReason}
                label="Reject Option"
                onChange={(event) => { setNotAttendedReason(event.target.value) }}
                required
                >
                    {
                        reasons.map((ele)=>(
                            <MenuItem value={ele}>{ele}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </div>
            {
                notAttendedReason === "Others" ?
                <div className="pb-10">
                    <FormControl className="w-full">
                        <TextField
                            sx={{ '& .MuiOutlinedInput-input, .MuiInputLabel-root': { fontSize: 14 } }}
                            id="outlined-multiline-static-reject-option"
                            label="Reason For Not Attended*"
                            placeholder="Please Write reason here."
                            name="reasonNotAttended"
                            onChange={(event) => setNotes(event.target.value)}

                            value={notes}
                        />
                    </FormControl>
                </div>
                :null
            }
        </div>
        :
        <></>
    ) 


    return (
        <div className="mt-5">
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(event) => submitDetails(event)}
            >
                {
                    !bulkFlag ?
                        <div className="pb-5">
                            <div>
                                <span className="text-gray-600 text-sm"> Requested date of visit  <span className="text-red-500 font-semibold"> * </span> : </span>
                                <span className="text-gray-600 font-semibold text-sm"> 
                                {/* {getAppointmentDate(details.formattedfulfillmentDate)} 
                                {getAppointmentTime(details.formattedfulfillmentDate)} */}

                                {moment(details.formattedfulfillmentDate).format("ddd MMM DD YYYY ")} 
                                {moment(details.formattedfulfillmentDate).format("hh:mm A")}
                                 </span>
                            </div>
                        </div> : <></>
                }


                {
                    !bulkFlag && markAttendance ?
                        <div className="pb-5">
                            <div className="m-auto">
                                <span className="text-gray-600 font-semibold text-sm">
                                    <FormControl className="w-full">
                                        <TextField
                                            id="callbackdate"
                                            name="callbackdate"
                                            label="Actual date of visit*"
                                            type="datetime-local"
                                            value={callbackdate}
                                            InputProps={{ inputProps: { min: details.formattedfulfillmentDate, max: new Date().toISOString().slice(0,19) }}}
                                            onChange={(event) => handleFieldChange(event)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </FormControl>
                                </span>
                            </div>
                        </div> : <></>
                }


                {
                    !bulkFlag && markAttendance ?
                        <div className="pb-5">
                            <FormControl className="w-full pb-10">
                                <InputLabel id="feedback">Select your Feedback</InputLabel>
                                <Select
                                    labelId="feedback"
                                    id="feedback"
                                    name="feedback"
                                    onChange={(event) => handleFieldChange(event)}
                                    label="Select type of status"
                                >
                                    <MenuItem value={'Satisfied'}>Satisfied</MenuItem>
                                    <MenuItem value={'Dissatisfied'}>Dissatisfied</MenuItem>
                                    <MenuItem value={'Pacifistic'}>Pacifistic</MenuItem>
                                </Select>
                            </FormControl>
                        </div> : <></>
                }

                {
                    !markAttendance?
                    rejectionOptions
                    :
                <div className="pb-10">
                    <FormControl className="w-full">
                        <TextField
                            sx={{ '& .MuiOutlinedInput-input, .MuiInputLabel-root': { fontSize: 14 } }}
                            id="outlined-multiline-static"
                            label="Remarks*"
                            multiline
                            name="notes"
                            onChange={(event) => handleFieldChange(event)}
                            rows={4}
                            value={notes}
                        />
                    </FormControl>
                </div>
                }

                <div className='pb-5 flex justify-between text-center'>
                    <div className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold" type="submit" variant="contained" size="large" onClick={closePopUp}>
                        <span>
                            Cancel
                        </span>
                    </div>

                    {
                        markAttendance ?
                            <div className={ (callbackdate||bulkFlag) && notes ?"border border-green-600 bg-green-600 text-gray-100 rounded-md w-40 p-1 text-sm cursor-pointer font-semibold":"border text-gray-100 rounded-md w-40 p-1 text-sm  bg-green-300 border-green-300  font-semibold"} type="submit" variant="contained" size="large" onClick={(callbackdate || bulkFlag) && notes ? submitDetails : undefined}>
                                <span>
                                    Mark Attended
                                </span>
                            </div>
                            : <div className={ notAttendedReason.length>=10 || (notAttendedReason==="Others" && notes) ?"border border-red-600 bg-red-600 text-gray-100 rounded-md w-40 p-1 text-sm cursor-pointer font-semibold":"border text-gray-100 rounded-md w-40 p-1 text-sm  bg-red-300 border-red-300  font-semibold"} type="submit" variant="contained" size="large" onClick={notAttendedReason.length>=10 || (notAttendedReason==="Others" && notes) ? submitDetails : undefined}>
                                <span>
                                    Mark Not Attended
                                </span>
                            </div>
                    }

                </div>
            </Box>
        </div>
    );
}